export const colors: { [key: string]: string } = {
    green: '#2D7E24',
    red: '#C70032',
    primaryBlue: '#0057B8',
    secondaryBlue: '#009FDB',
    primaryGray: '#686E74',
    secondaryGray: '#BDC2C7',
    purple: '#AF29BB',
    lightBlue: '#59C7FA',
    yellow: '#FFB000',
    orange: '#EA712F'
};